import { render, staticRenderFns } from "./PageGuide.vue?vue&type=template&id=329e32ee&"
import script from "./PageGuide.vue?vue&type=script&lang=ts&"
export * from "./PageGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports